import React, { useState, useRef, useEffect } from "react";
import "./style.css";
import ChatBotButtons from "./ChatBotButtons";
import BotHeaderImage from './assets/VIA3.png'

const ChatBotModal = ({
  isOpen,
  onClose,
  children,
  goBack,
  resetChat,
  navStack,
}) => {
  const [position, setPosition] = useState({ x: -10, y: -10 });
  const [dragging, setDragging] = useState(false);
  const dragOffset = useRef({ x: 0, y: 0 });
  const containerRef = useRef(null);

  const onMouseDownHeader = (e) => {
    setDragging(true);
    dragOffset.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    };
    document.body.style.userSelect = "none";
  };
  const onMouseMove = (e) => {
    if (!dragging) return;
    setPosition({
      x: e.clientX - dragOffset.current.x,
      y: e.clientY - dragOffset.current.y,
    });
  };
  const onMouseUp = () => {
    setDragging(false);
    document.body.style.userSelect = "";
  };
  useEffect(() => {
    if (dragging) {
      window.addEventListener("mousemove", onMouseMove);
      window.addEventListener("mouseup", onMouseUp);
    } else {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    }
    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };
  }, [dragging]);

  if (!isOpen) return null;
  return (
    <div className="modal-overlay-bot">
      <div
        className="modal-container-bot"
        ref={containerRef}
        style={{
          right: -position.x,
          bottom: -position.y,
          width: "25%",
          height: "75%",
          position: "absolute"
        }}
      >
        <div
          className="modal-header-bot"
          onMouseDown={onMouseDownHeader}
          style={{ cursor: "move" }}
        >
          <img src={BotHeaderImage} alt = 'Bot Image' width={'30px'} style={{ marginRight: '8px' }}/>
          <span>AMI - Medical Information's Digital Assistant</span>
          <button onClick={onClose}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              fill="white"
              viewBox="0 0 16 16"
            >
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
            </svg>
          </button>
        </div>
        <ChatBotButtons
          goBack={goBack}
          resetChat={resetChat}
          navStack={navStack}
        />
        <div className="modal-content-bot">{children}</div>
      </div>
    </div>
  );
};

export default ChatBotModal;



// WEBPACK FOOTER //
// ./src/mi-app/AMI_assistant/ChatBotModal.js